import React, { Component } from 'react'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'
import { bindActionCreators } from 'redux'
import classNames from 'classnames'

import {
  FormattedMessage,
} from 'react-intl'

import {
  PriceNameRange,
} from 'components'

import {
  makeSelectPrices,
} from 'logic/pcts'

import {
  setQty,
  setPriceName,
  makeSelectQty,
  makeSelectTresholds,
  makeSelectQtyForPriceName,
  makeSelectControlsEnabled,
} from 'logic/orders'

import { makeSelectCurOrg } from 'logic/orgs';

import messages from 'i18n/messages';

class PriceTypeItem extends Component {

  qty = () => this.props.priceQty || 0

  getSetQtyHandler = increase =>
    () => this.props.controlsEnabled
          && !this.isDisabled(increase)
          && this.props.actions.setQty(increase ? this.qty() + 1 : this.qty() - 1, this.props.price)

  isDisabled = increase =>
    increase
      ? this.props.qty >= this.props.tresholds.max
      : this.props.priceQty <= 0

  handleTogglePriceName = () =>
    this.props.actions.setPriceName(this.props.price.name)

  render() {
    const { controlsEnabled, price, priceQty } = this.props
    return (
      <div className="price-item">
        <div className="price-name">
          <div>{price.name}</div>
          <div className="price-desc" dangerouslySetInnerHTML={{ __html: price.desc }} />
        </div>
        <div className="price-value">
          <div className="font-weight-bold"><PriceNameRange priceName={price.name} /></div>
          <small><FormattedMessage {...messages.perSeat} /></small>
        </div>
        <div className="qty-switches">
          <div className={classNames('qty-btn', { disabled: !controlsEnabled || this.isDisabled(false) })} onClick={this.getSetQtyHandler(false)}>
            <span className="tt-icon tt-icon-i-delete" />
          </div>
          <div className="qty-value">
            {priceQty}
          </div>
          <div className={classNames('qty-btn', { disabled: !controlsEnabled || this.isDisabled(true) })} onClick={this.getSetQtyHandler(true)}>
            <span className="tt-icon tt-icon-i-add" />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  qty: makeSelectQty(),
  priceQty: makeSelectQtyForPriceName(props => props.price.name),
  tresholds: makeSelectTresholds(),
  prices: makeSelectPrices(),
  controlsEnabled: makeSelectControlsEnabled(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setQty,
    setPriceName,
  }, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(PriceTypeItem)
